<template>
    <div class="list-page daiban">
        <Header></Header> <!-- 头部 -->
        <div class="content bg">
            <van-tabs @click="onApply" class="detail-lists" v-model="joa_activeTabName">
                <van-tab v-for="item_tabs in joa_tabs" :name="item_tabs">
                    <div slot="title" v-if="item_tabs == 'ALL'">ALL<span id="all_need_count_show"
                                                                         class="van-info"></span></div>
                    <div v-else slot="title">{{item_tabs}}<span :id="item_tabs+'_need_count_show'"
                                                                class="van-info"></span></div>
                    <van-list
                            v-model="joa_loading"
                            :finished="joa_finished"
                            finished-text=" "
                            @load="onLoad"
                    >
                        <!-- 全部 -->
                        <!-- <div id="allListShow" v-if="item_tabs == 'ALL'">
                            <iframe scrolling="auto" width="100%" :height="allListShowHeight" style="margin-top:-5px;" frameborder="no" border="0" src=""></iframe>
                        </div> -->
                        <!-- 其他 -->
                        <div class="reply-user" v-for="(item,index) in joa_list" :id="item.applyNo">
                            <a class="ah" v-if="item_tabs == 'OA'" :href="item.url">
                                <van-card
                                        thumb="http://oa.cecport.com/Upload/EmpPic/PhotoStorage/337A2EF8DF3B4064AC22F065B5D7F88F.jpg">
                                    <div slot="title">
                                        <span class="user-name">黄康梅</span>
                                        <span class="user-dept">系统开发二部</span>
                                    </div>
                                    <div slot="footer">
                                        <span class="category">{{item.processName}}</span>
                                        <p class="date">{{item.createTime | formatDateMD}}</p>
                                    </div>
                                </van-card>
                            </a>
                            <a class="ah" style="display: block;z-index: 9999;"
                               v-else-if="item_tabs == 'EHR' && item.businessName && item.businessName.indexOf('外出') !== -1"
                               @click="goHref(WEB_URL+'ehrdetail?types=wc&number='+item.applyNo+source)">
                                <van-card>
                                    <div slot="thumb">
                                        <img style="border-radius:50%" :src="item.applyUserPic" @error="onErrorImage"/>
                                    </div>
                                    <div slot="title">
                                        <span class="user-name">{{item.applyUserName}}</span>
                                        <span class="user-dept">{{item.applyDeptName}}</span>
                                    </div>
                                    <div slot="footer">
                                        <span class="category">{{item.businessName.replace('审批', '')}}</span>
                                        <p class="date">{{item.currentTaskAssignDate | formatDateMD}}</p>
                                    </div>
                                </van-card>
                            </a>
                            <a class="ah" style="display: block;z-index: 9999;"
                               v-else-if="item_tabs == 'EHR' && item.businessName && item.businessName.indexOf('请假') !== -1"
                               @click="goHref(WEB_URL+'ehrdetail?types=qj&number='+item.applyNo+source)">
                                <van-card>
                                    <div slot="thumb">
                                        <img style="border-radius:50%" :src="item.applyUserPic" @error="onErrorImage"/>
                                    </div>
                                    <div slot="title">
                                        <span class="user-name">{{item.applyUserName}}</span>
                                        <span class="user-dept">{{item.applyDeptName}}</span>
                                    </div>
                                    <div slot="footer">
                                        <span class="category">{{item.businessName.replace('审批', '')}}</span>
                                        <p class="date">{{item.currentTaskAssignDate | formatDateMD}}</p>
                                    </div>
                                </van-card>
                            </a>
                            <a class="ah" style="display: block;z-index: 9999;"
                               v-else-if="item_tabs == 'EHR' && item.businessName && item.businessName.indexOf('补卡') !== -1"
                               @click="goHref(WEB_URL+'ehrdetail?types=bk&number='+item.applyNo+source)">
                                <van-card>
                                    <div slot="thumb">
                                        <img style="border-radius:50%" :src="item.applyUserPic" @error="onErrorImage"/>
                                    </div>

                                    <div slot="title">
                                        <span class="user-name">{{item.applyUserName}}</span>
                                        <span class="user-dept">{{item.applyDeptName}}</span>
                                    </div>
                                    <div slot="footer">
                                        <span class="category">{{item.businessName.replace('审批', '')}}</span>
                                        <p class="date">{{item.currentTaskAssignDate | formatDateMD}}</p>
                                    </div>
                                </van-card>
                            </a>
                            <a class="ah" style="display: block;z-index: 9999;" v-else-if="item_tabs == 'FSSC'"
                               @click="goHref(item.url)">
                                <van-card>
                                    <div slot="thumb">
                                        <img style="border-radius:50%" :src="item.applyUserPic" @error="onErrorImage"/>
                                    </div>

                                    <div slot="title">
                                        <span class="user-name">{{item.applyUserName}}</span>
                                        <span class="user-dept">{{item.applyDeptName}}</span>
                                    </div>
                                    <div slot="footer">
                                        <span class="category">{{item.businessName}}</span>
                                        <p class="date">{{item.currentTaskAssignDate | formatDateMD}}</p>
                                    </div>
                                </van-card>
                            </a>
                            <van-collapse v-if="item_tabs == 'FSSC'" v-model="joa_activeReplyBox" accordion>
                                <van-collapse-item :name="item.applyNo">
                                    <div slot="title" class="title">
                                        {{item.title}}
                                    </div>
                                    <div class="reply-box" :id="'reply-box'+item.id">
                                        <div v-if="item.businessName && item.businessName.indexOf('差旅') !== -1">
                                            <p class="price"><span>预计费用：</span>{{item.currencyCode}} {{item.amount |
                                                formatNum}}</p>
                                            <p><span>出差说明：</span>{{item.remark}}</p>
                                            <p><span>出差时间：</span>{{item.startDate | formatDate}} 至 {{item.endDate |
                                                formatDate}}</p>
                                        </div>
                                        <div v-else-if="item.businessName && item.businessName.indexOf('差旅费报销') !== -1">
                                            <p class="price"><span>报销金额：</span>{{item.currencyCode}}{{item.amount |
                                                formatNum}}</p>
                                            <p><span>出差说明：</span>{{item.remark}}</p>
                                            <p><span>出差时间：</span>{{item.startDate | formatDate}} 至 {{item.endDate |
                                                formatDate}}</p>
                                        </div>
                                        <div v-else-if="item.businessName && item.businessName.indexOf('招待费申请') !== -1">
                                            <p class="price"><span>预计费用：</span>{{item.currencyCode}}{{item.amount |
                                                formatNum}}</p>
                                            <p><span>招待说明：</span>{{item.remark}}</p>
                                        </div>
                                        <div v-else-if="item.businessName && item.businessName.indexOf('招待报销') !== -1">
                                            <p class="price"><span>报销金额：</span>{{item.currencyCode}}{{item.amount |
                                                formatNum}}</p>
                                            <p><span>招待说明：</span>{{item.remark}}</p>
                                        </div>
                                        <div v-else-if="item.businessName && item.businessName.indexOf('资金付款') !== -1">
                                            <p class="price"><span>付款金额：</span>{{item.currencyCode}}{{item.amount |
                                                formatNum}}</p>
                                            <p><span>供应商名称：</span>{{item.vendorName}}</p>
                                            <p><span>支付期限：</span>{{item.paymentDate | formatDate}}</p>
                                        </div>
                                        <div v-else-if="item.businessName && item.businessName.indexOf('对外支付') !== -1">
                                            <p class="price"><span>付款金额：</span>{{item.currencyCode}}{{item.amount |
                                                formatNum}}</p>
                                            <p><span>供应商名称：</span>{{item.vendorName}}</p>
                                            <p><span>支付期限：</span>{{item.paymentDate | formatDate}}</p>
                                        </div>
                                        <div v-else-if="item.businessName && item.businessName.indexOf('资产采购支付') !== -1">
                                            <p class="price"><span>付款金额：</span>{{item.currencyCode}}{{item.amount |
                                                formatNum}}</p>
                                            <p><span>供应商名称：</span>{{item.vendorName}}</p>
                                            <p><span>支付期限：</span>{{item.paymentDate | formatDate}}</p>
                                        </div>
                                        <div v-else-if="item.businessName && item.businessName.indexOf('项目') !== -1">
                                            <p><span>项目名称：</span>{{item.projectName}}</p>
                                        </div>
                                        <div v-else>
                                            <p class="price"><span>报销金额：</span>{{item.currencyCode}}{{item.amount |
                                                formatNum}}</p>
                                        </div>

                                        <h4>审批意见</h4>
                                        <van-cell-group>
                                            <van-field
                                                    class="textarea"
                                                    rows="1"
                                                    type="textarea"
                                                    placeholder="请输入"
                                            />
                                        </van-cell-group>
                                        <div class="reply-btn">
                                            <van-button @click="onSubmit(item.id,item.applyNo,true)" type="default"
                                                        size="normal">拒绝
                                            </van-button>
                                            <van-button @click="onSubmit(item.id,item.applyNo,false)" type="info"
                                                        size="normal" class="right">同意
                                            </van-button>
                                        </div>
                                    </div>
                                </van-collapse-item>
                            </van-collapse>
                            <van-collapse v-else-if="item_tabs == 'EHR'" v-model="joa_activeReplyBox" accordion>
                                <van-collapse-item :name="item.applyNo">
                                    <div slot="title" class="title">
                                        {{item.title}}
                                    </div>
                                    <div class="reply-box" :id="'reply-box'+item.id">
                                        <div v-if="item.businessName && item.businessName.indexOf('外出') !== -1"
                                             slot="title">
                                            <p><span>外出时长：</span>{{item.hrTime}}</p>
                                            <p><span>外出类型：</span>{{item.hrType}}</p>
                                            <p><span>同行人员：</span>{{item.peeEmps}}</p>
                                            <p><span>外出时间：</span>{{item.startDate.substr(0,16)}}至{{item.endDate.substr(0,16)}}
                                            </p>
                                            <p><span>外出原因：</span>{{item.hrReason}}</p>
                                        </div>
                                        <div v-else-if="item.businessName && item.businessName.indexOf('补卡') !== -1"
                                             slot="title">
                                            <p><span>补卡时间：</span>{{item.hrTime.substr(0,16)}}</p>
                                            <p><span>证明人：</span>{{item.peeEmps}}</p>
                                            <p><span>补卡原因：</span>{{item.hrReason}}</p>
                                        </div>
                                        <div v-else-if="item.businessName && item.businessName.indexOf('请假') !== -1"
                                             slot="title">
                                            <p><span>请假时长：</span>{{item.hrTime}}</p>
                                            <p><span>请假类型：</span>{{item.hrType}}</p>
                                            <p><span>请假时间：</span>{{item.startDate.substr(0,16)}}至{{item.endDate.substr(0,16)}}
                                            </p>
                                            <p><span>工作交接人：</span>{{item.peeEmps}}</p>
                                            <p><span>本部门请假人员：</span>{{item.atsEmps}}</p>
                                            <p><span>请假原因：</span>{{item.hrReason}}</p>
                                        </div>

                                        <p v-if="item.businessName && item.businessName.indexOf('请假') !== -1 && typeof(item.hrFiles) !='undefined' "
                                           style="color: #333;"><span>附件：</span></p>
                                        <van-grid :border="false" :column-num="3"
                                                  v-if=" typeof(item.hrFiles) !='undefined' ">
                                            <van-grid-item v-for="(att_item,att_index) in JSON.parse(item.hrFiles)">
                                                <van-image v-if="attache_houzhuis.includes(att_item.type)==true"
                                                           :src="att_item.file" @click="showImage(att_index,item.id)"/>
                                                <a v-else :href="att_item.file">
                                                    <van-icon v-if="att_item.file.indexOf('pdf') !== -1"
                                                              :name="WEB_URL+'images/icon-pdf.png'" size="50"/>
                                                    <van-icon
                                                            v-else-if="att_item.file.indexOf('xls') !== -1 || att_item.file.indexOf('xlsx') !== -1"
                                                            :name="WEB_URL+'images/icon-excel.png'" size="50"/>
                                                    <van-icon
                                                            v-else-if="att_item.file.indexOf('doc') !== -1 || att_item.file.indexOf('docx') !== -1"
                                                            :name="WEB_URL+'images/icon-doc.png'" size="50"/>
                                                    <van-icon v-else name="envelop-o" size="100" color="#ddd"/>
                                                </a>
                                            </van-grid-item>
                                        </van-grid>
                                        <van-image-preview :start-position="image_start_position"
                                                           v-model="is_image_show" :images="images"></van-image-preview>
                                        <h4>审批意见</h4>
                                        <van-cell-group>
                                            <van-field
                                                    class="textarea"
                                                    rows="1"
                                                    type="textarea"
                                                    placeholder="请输入"
                                            />
                                        </van-cell-group>
                                        <div class="reply-btn">
                                            <van-button @click="onSubmitEHR(item.id,item.applyNo,false)" type="default"
                                                        size="normal">拒绝
                                            </van-button>
                                            <van-button @click="onSubmitEHR(item.id,item.applyNo,true)" type="info"
                                                        size="normal" class="right">同意
                                            </van-button>
                                        </div>
                                    </div>
                                </van-collapse-item>
                            </van-collapse>
                            <van-collapse v-else v-model="joa_activeReplyBox" accordion>
                                <van-collapse-item :name="item.id">
                                    <div slot="title" class="title">
                                        {{item.titleInfo}}
                                    </div>
                                    <div class="reply-box" :id="'reply-box'+item.id">
                                        <div slot="title">
                                            <p><span>暂挂原因：</span>逾期454天</p>
                                            <p><span>交货金额：</span>3200.000</p>
                                            <p><span>币别：</span>USD</p>
                                            <p><span>客户名称：</span>深圳市天珑移动技术有限公司</p>
                                        </div>
                                        <h4>审批意见</h4>
                                        <van-cell-group>
                                            <van-field
                                                    class="textarea"
                                                    rows="1"
                                                    type="textarea"
                                                    placeholder="请输入"
                                            />
                                        </van-cell-group>
                                        <div class="reply-btn">
                                            <van-button @click="onSubmitOA(item.id,false)" type="default" size="normal">
                                                拒绝
                                            </van-button>
                                            <van-button @click="onSubmitOA(item.id,true)" type="info" size="normal"
                                                        class="right">同意
                                            </van-button>
                                        </div>
                                    </div>
                                </van-collapse-item>
                            </van-collapse>
                        </div>
                    </van-list>
                </van-tab>
            </van-tabs>
            <NoOperations></NoOperations> <!-- 没有操作数据-->
            <Footer></Footer> <!-- 尾部 -->
        </div>
    </div>
</template>

<script type="text/javascript">
    import axios from 'axios';

    export default {
        created() {
            var $rus = this.$router.history;
            if ($rus["current"].fullPath.indexOf('sys=ehr') !== -1) {
                this.joa_activeTabName = "EHR";
                this.joa_systemId = "EHR";
                this.joa_page = 0;
                this.getData("EHR"); //获取数据
            } else if ($rus["current"].fullPath.indexOf('sys=fssc') !== -1) {
                this.joa_activeTabName = "FSSC";
                this.joa_systemId = "FSSC";
                this.joa_page = 0;
                this.getData("FSSC"); //获取数据
            } else if ($rus["current"].fullPath.indexOf('sys=oa') !== -1) {
                this.joa_activeTabName = "OA";
                this.joa_systemId = "OA";
                this.joa_page = 0;
                this.getDataOA("OA"); //获取数据
            } else {
                this.joa_activeTabName = "FSSC";
                this.joa_systemId = "FSSC";
                this.joa_page = 0;
                this.getData("FSSC"); //获取数据
            }
            //获取待办数量
            this.getSysCount();
        },
        mounted() {
            //this.allListShowHeight=$(".content.bg").height()+60;
        },
        data() {
            return {
                ADMIN: JSON.parse(localStorage.getItem('LS_ADMIN')),
                WEB_URL: this.CoreNew.WEB_URL,
                JOA_URL: this.CoreNew.JOA_URL,
                URLTOKEN: encodeURIComponent(JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))),
                oa_need_count: 0,
                fssc_need_count: 0,
                ehr_need_count: 0,
                allListShowHeight: 0,
                joa_activeTabName: "FSSC",
                joa_activeReplyBox: 1,
                //joa_tabs: ["OA","FSSC","EHR","ALL"],
                // joa_tabs: ["FSSC", "EHR", "ALL"],
                joa_tabs: ["FSSC", "ALL"], // 20230222 新hr上线取消 hr的快捷审批
                joa_list: [],
                joa_total: 0,
                joa_page: 0,
                joa_loading: false,
                joa_finished: false,
                joa_systemId: "FSSC",
                activeNames: ['0'],
                attaches_list: [],
                is_image_show: false,
                image_start_position: 0,
                images: [],
                attache_houzhuis: ['bmp', 'jpg', 'jpeg', 'png', 'tif', 'gif', 'pcx', 'tga', 'exif', 'fpx', 'svg', 'psd', 'cdr', 'pcd', 'dxf', 'ufo', 'eps', 'ai', 'raw', 'WMF', 'webp'],
                source: ''
            };
        },
        filters: {
            formatNum: function (value) {
                if (!value) return '0.00';
                var intPart = Number(value).toFixed(0);
                var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
                var floatPart = ".00";
                var value2Array = value.toString().split(".");
                if (value2Array.length == 2) {
                    floatPart = value2Array[1].toString();
                    if (floatPart.length == 1) {
                        return intPartFormat + "." + floatPart + '0';
                    } else {
                        return intPartFormat + "." + floatPart;
                    }
                } else {
                    return intPartFormat + floatPart;
                }
                //return value.toFixed(2);
            },
            formatDateMD: function (value) {
                let date = new Date(value);
                let y = date.getFullYear();
                let MM = date.getMonth() + 1;
                MM = MM < 10 ? ('0' + MM) : MM;
                let d = date.getDate();
                d = d < 10 ? ('0' + d) : d;
                let h = date.getHours();
                h = h < 10 ? ('0' + h) : h;
                let m = date.getMinutes();
                m = m < 10 ? ('0' + m) : m;
                let s = date.getSeconds();
                s = s < 10 ? ('0' + s) : s;
                return MM + '/' + d + ' ' + h + ':' + m;
            },
            formatDate: function (value) {
                let date = new Date(value);
                let y = date.getFullYear();
                let MM = date.getMonth() + 1;
                MM = MM < 10 ? ('0' + MM) : MM;
                let d = date.getDate();
                d = d < 10 ? ('0' + d) : d;
                let h = date.getHours();
                h = h < 10 ? ('0' + h) : h;
                let m = date.getMinutes();
                m = m < 10 ? ('0' + m) : m;
                let s = date.getSeconds();
                s = s < 10 ? ('0' + s) : s;
                //return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
                return y + '-' + MM + '-' + d;
            },
            formatDateHM: function (value) {
                let date = new Date(value);
                let y = date.getFullYear();
                let MM = date.getMonth() + 1;
                MM = MM < 10 ? ('0' + MM) : MM;
                let d = date.getDate();
                d = d < 10 ? ('0' + d) : d;
                let h = date.getHours();
                h = h < 10 ? ('0' + h) : h;
                let m = date.getMinutes();
                m = m < 10 ? ('0' + m) : m;
                let s = date.getSeconds();
                s = s < 10 ? ('0' + s) : s;
                return y + '-' + MM + '-' + d + ' ' + h + ':' + m;
            }
        },
        mounted(){
            if(this.CoreNew.WEB_URL_SOURCE){
                this.source='&source='+this.CoreNew.WEB_URL_SOURCE
            }
        },
        methods: {
            goHref: function (url) {
                $("#loading").show();
                window.location.href = url;
            },
            onErrorImage: function (e) {
                var img = e.srcElement;
                img.src = "https://portal.cecport.com/static/noavatar.gif";
                img.onerror = null
            },
            getSysCount: function () {
                // axios.get(this.CoreNew.OA_API_IP + "joa-wf/mobile/todoTotalSum", {
                axios.get(this.CoreNew.OA_API_IP + "api/wf/mobile/todoTotalSum", {

                    headers: {'Authorization': JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
                }).then(function (response) {
                    var $rs = response.data;
                    if ($rs.flag == true) {
                        this.oa_need_count = $rs.data.oaTotal;
                        this.fssc_need_count = $rs.data.fsscTotal;
                        this.ehr_need_count = $rs.data.ehrTotal;
                        if (this.oa_need_count > 0) {
                            $("#OA_need_count_show").html(this.oa_need_count);
                        }
                        if (this.fssc_need_count > 0) {
                            $("#FSSC_need_count_show").html(this.fssc_need_count);
                        }
                        if (this.ehr_need_count > 0) {
                            $("#EHR_need_count_show").html(this.ehr_need_count);
                        }
                    }
                }.bind(this)).catch(function (error) {
                    //alert("请求--各自系统总数显示--失败"+error);
                    $("#sys_error").show();
                    this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')), "请求--各自系统总数显示--失败" + error);//记录错误
                    //console.log("请求--各自系统总数显示--失败"+error);
                });
            },
            checkAttaches: function (id, applyNo) {
                if ($("#reply-box" + id + " .van-grid").length == 0) {
                    let post_data = new FormData();
                    var str_json_data = '{"type":"3","types":"qj","number":"' + applyNo + '"}';
                    post_data.append("param", str_json_data);
                    axios.post(this.CoreNew.OA_API_IP + "joa-business/ehr/getLeaveParam/", post_data, {
                        headers: {'Authorization': JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
                    }).then(function (response) {
                        var details = JSON.parse(response.data.data);
                        if (details.files.length > 0) {
                            var _html = '';
                            _html += '<div class="van-grid">';
                            for (var i = 0; i < details.files.length; i++) {
                                if (this.attache_houzhuis.includes(details.files[i].type) == true) {
                                    _html += '	<div class="van-grid-item" style="flex-basis: 33.3333%;">';
                                    _html += '		<div class="van-grid-item__content van-grid-item__content--center">';
                                    _html += '			<div class="van-image"><img class="van-image__img" src="' + 'data:image/' + details.files[i].type + ';base64,' + details.files[i].file + '"></div>';
                                    _html += '		</div>';
                                    _html += '	</div>';
                                } else {
                                    _html += '	<div class="van-grid-item" style="flex-basis: 33.3333%;">';
                                    _html += '		<div class="van-grid-item__content van-grid-item__content--center">';
                                    _html += '			<a onclick="showFilesList(1,1,2)"><i class="van-icon van-icon-envelop-o" style="color: rgb(221, 221, 221); font-size: 100px;"></i></a>';
                                    _html += '		</div>';
                                    _html += '	</div>';
                                }
                            }
                            _html += '</div>';
                            $("#reply-box" + id + " h4").before(_html);
                        }
                    }.bind(this)).catch(function (error) {
                        //alert("请求EHR--获取单据详细信息--失败"+error);
                        this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')), "请求EHR--获取单据详细信息--失败" + error);//记录错误
                        console.log("请求EHR--获取单据详细信息--失败" + error);
                    });
                }
            },
            showFiles: function (type, filename, content) {
                var myForm = document.createElement("form");
                myForm.method = "post";
                myForm.action = this.CoreNew.WEB_PHP_URL + "showpdf.php";
                var myInputType = document.createElement("input");
                myInputType.setAttribute("name", "type");
                myInputType.setAttribute("value", type);
                myForm.appendChild(myInputType);

                var myInputFilename = document.createElement("input");
                myInputFilename.setAttribute("name", "filename");
                myInputFilename.setAttribute("value", filename);
                myForm.appendChild(myInputFilename);

                var myInputContent = document.createElement("input");
                myInputContent.setAttribute("name", "content");
                myInputContent.setAttribute("value", content);
                myForm.appendChild(myInputContent);

                document.body.appendChild(myForm);
                myForm.submit();
                document.body.removeChild(myForm);
            },
            showImage: function (index, id) {
                this.is_image_show = true;
                this.image_start_position = index;
                this.images[0] = $("#reply-box" + id + " img").attr("src");
            },
            onApply: function (name, title) {
                this.joa_list = [];
                $(".no-datas").removeClass("show");
                if (name == "FSSC") {
                    this.joa_systemId = "FSSC";
                    this.joa_page = 0;
                    this.getData("FSSC"); //获取数据
                    //window.location.href=this.CoreNew.FSSC_URL+"html5Travel/mobileTodo";
                } else if (name == "EHR") {
                    this.joa_systemId = "EHR";
                    this.joa_page = 0;
                    this.getData("EHR");
                } else if (name == "OA") {
                    this.joa_systemId = "OA";
                    this.joa_page = 0;
                    this.getDataOA("OA");
                } else { //更多
                    //var url=this.CoreNew.JOA_URL+encodeURIComponent("task.html#/todo");
                    //var url=this.CoreNew.JOA_URL+"task.html#/todo";   //请求的URl
                    /*var url="http://10.2.22.10:8080/news/";
                    var xhr = new XMLHttpRequest();
                    xhr.open("GET", url, true);
                    xhr.setRequestHeader("Authorization",JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION')));
                    xhr.send();
                    return false;
                    var a = document.createElement('a');
                    a.href = url;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);*/
                    window.location.href = this.CoreNew.JOA_URL + "task.html#/todo?username=" + encodeURIComponent(this.ADMIN.USER_ACCOUNT) + "&token=" + this.URLTOKEN;
                    //this.joa_systemId="OA";this.joa_page=0;this.getData("OA");
                }
            },
            onSubmit: function (id, applyNo, isReject) {
                $("#loading").show();
                let post_data = new FormData();
                post_data.append("id", id);
                if (applyNo != '') {
                    post_data.append("no", applyNo);
                }
                post_data.append("isReject", isReject);
                post_data.append("remark", $("#reply-box" + id + " textarea").val());
                axios.post(this.CoreNew.OA_API_IP + "joa-business/mobile/approve", post_data, {
                    headers: {'Authorization': JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
                }).then(function (response) {
                    var $rs = response.data;
                    //Toast.setDefaultOptions({ duration: 30000 });
                    if ($rs.flag == true) {
                        $("#loading").hide();
                        var _num = parseInt($("#FSSC_need_count_show").html()) - 1;
                        if (_num < 0) {
                            $("#FSSC_need_count_show").html("");
                            $("#FSSC_need_count_show .van-info").hide();
                        } else {
                            $("#FSSC_need_count_show").html(_num);
                            $("#FSSC_need_count_show .van-info").show();
                        }
                        var sum_num = parseInt($("#need_count .van-info").html()) - 1;
                        if (sum_num <= 0) {
                            $("#need_count .van-info").html("");
                            $("#need_count .van-info").hide();
                            $("#all_need_count_show").html("");
                            $("#all_need_count_show .van-info").hide();
                        } else {
                            $("#need_count .van-info").html(sum_num);
                            $("#need_count .van-info").show();
                            $("#all_need_count_show").html(sum_num);
                            $("#all_need_count_show .van-info").show();
                        }
                        $(".content .reply-user#" + applyNo).remove();
                        this.$toast($rs.message);
                    } else {
                        $("#loading").hide();
                        this.$toast.setDefaultOptions({duration: 3000});
                        this.$toast($rs.message);
                    }
                }.bind(this)).catch(function (error) {
                    $("#loading").hide();
                    //alert("请求--保存待办--失败"+error);
                    this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')), "请求--保存待办--失败" + error);//记录错误
                    console.log("请求--保存待办--失败" + error);
                });
            },
            onSubmitOA: function (id, isReject) {
                //提交
                $("#loading").show();
                let post_data = new FormData();
                post_data.append("message", $("#reply-box" + id + " textarea").val());
                post_data.append("taskId", id);
                post_data.append("userId", JSON.parse(localStorage.getItem('LS_ADMIN_USER_ID')));
                if (isReject == true) { //同意
                    var _url = this.CoreNew.OA_API_IP + "joa-workflow/act-process-task/completeTask/";
                } else { //拒绝
                    var _url = this.CoreNew.OA_API_IP + "joa-workflow/act-process-task/rejectTask/";
                }
                axios.post(_url, post_data, {
                    headers: {'Authorization': JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
                }).then(function (response) {
                    var $rs = JSON.parse(response.data.data);
                    $("#loading").hide();
                    if (response.data.flag == true && response.data.message.indexOf("通过") == 0) {
                        this.$toast("操作成功");
                        var _num = parseInt($("#OA_need_count_show").html()) - 1;
                        if (_num <= 0) {
                            $("#OA_need_count_show").html("");
                            $("#OA_need_count_show .van-info").hide();
                        } else {
                            $("#OA_need_count_show").html(_num);
                            $("#OA_need_count_show .van-info").show();
                        }
                        var sum_num = parseInt($("#need_count .van-info").html()) - 1;
                        if (sum_num <= 0) {
                            $("#need_count .van-info").html("");
                            $("#need_count .van-info").hide();
                            $("#all_need_count_show").html("");
                            $("#all_need_count_show .van-info").hide();
                        } else {
                            $("#need_count .van-info").html(sum_num);
                            $("#need_count .van-info").show();
                            $("#all_need_count_show").html(sum_num);
                            $("#all_need_count_show .van-info").show();
                        }
                        $(".content .reply-user#" + id).remove();
                    } else {
                        this.$toast(response.data.message);
                    }
                }.bind(this)).catch(function (error) {
                    $("#loading").hide();
                    //alert("请求EHR--快捷审批--失败"+error);
                    this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')), "请求EHR--快捷审批--失败" + error);//记录错误
                    console.log("请求EHR--快捷审批--失败" + error);
                });
            },
            onSubmitEHR: function (id, applyNo, isReject) {
                //提交
                $("#loading").show();
                var str_json_data = '{"assignment":"' + id + '","ispass":"' + isReject + '","opinion":"' + $("#reply-box" + id + " textarea").val() + '","penNumber":"' + this.ADMIN.USER_CODE + '"}';
                let post_data = new FormData();
                post_data.append("param", str_json_data);
                axios.post(this.CoreNew.OA_API_IP + "joa-business/ehr/passAssignment/", post_data, {
                    headers: {'Authorization': JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
                }).then(function (response) {
                    var $rs = JSON.parse(response.data.data);
                    $("#loading").hide();
                    if (response.data.flag == true && $rs.msg.indexOf("成功") == 0) {
                        this.$toast("操作成功");
                        var _num = parseInt($("#EHR_need_count_show").html()) - 1;
                        if (_num <= 0) {
                            $("#EHR_need_count_show").html("");
                            $("#EHR_need_count_show .van-info").hide();
                        } else {
                            $("#EHR_need_count_show").html(_num);
                            $("#EHR_need_count_show .van-info").show();
                        }
                        var sum_num = parseInt($("#need_count .van-info").html()) - 1;
                        if (sum_num <= 0) {
                            $("#need_count .van-info").html("");
                            $("#need_count .van-info").hide();
                            $("#all_need_count_show").html("");
                            $("#all_need_count_show .van-info").hide();
                        } else {
                            $("#need_count .van-info").html(sum_num);
                            $("#need_count .van-info").show();
                            $("#all_need_count_show").html(sum_num);
                            $("#all_need_count_show .van-info").show();
                        }
                        $(".content .reply-user#" + applyNo).remove();
                    } else {
                        this.$toast($rs.reson);
                    }
                }.bind(this)).catch(function (error) {
                    $("#loading").hide();
                    //alert("请求EHR--快捷审批--失败"+error);
                    this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')), "请求EHR--快捷审批--失败" + error);//记录错误
                    console.log("请求EHR--快捷审批--失败" + error);
                });
            },
            async getEHRAttaches(applyNo) {
                try {
                    let post_data = new FormData();
                    var str_json_data = '{"type":"3","types":"qj","number":"' + applyNo + '"}';
                    post_data.append("param", str_json_data);
                    const res = await axios.post(this.CoreNew.OA_API_IP + "joa-business/ehr/getLeaveParam/", post_data, {
                        headers: {'Authorization': JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
                    }).then(function (response) {
                        var details = JSON.parse(response.data.data);
                        if (details.files.length > 0) {
                            this.attaches_list[applyNo] = details.files;
                            //console.log(this.attaches_list);
                        }
                    }.bind(this)).catch(function (error) {
                        //alert("请求EHR--快捷审批--失败"+error);
                        this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')), "请求EHR--快捷审批--失败" + error);//记录错误
                        console.log("请求EHR--快捷审批--失败" + error);
                    });
                } catch (error) {
                }
            },
            getJsonData: function (files) {
                var files_list = JSON.parse(files);
                return files_list;
            },
            onLoad: function () {
                this.getData(this.joa_systemId); //获取数据
            },
            getDataOA: function (sid) {
                this.joa_page++;
                this.joa_loading = true;
                axios.get(this.CoreNew.OA_API_IP + "joa-workflow/act-process-task/queryToDoTask/" + this.joa_page + "/" + this.CoreNew.PAGESIZE + "?assignee=" + JSON.parse(localStorage.getItem('LS_ADMIN_USER_ID')), {
                    headers: {'Authorization': JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
                }).then(function (response) {
                    if (response.data.flag == true) {
                        if (response.data.data.length == 0) {
                            this.joa_list = [];
                            this.joa_loading = false;
                            this.joa_finished = true;
                            $(".no-datas").addClass("show");
                        } else {
                            var $rs = response.data.data;
                            $(".no-datas").removeClass("show");
                            this.joa_total = $rs.length;
                            var $list = $rs;
                            this.joa_list = this.joa_list.concat($list);
                            console.log(this.joa_list);
                            // 数据全部加载完成
                            this.joa_loading = false;
                            if (this.joa_list.length != 0 && (this.joa_list.length >= this.joa_total)) {
                                this.joa_finished = true;
                            }
                        }
                    }
                }.bind(this)).catch(function (error) {
                    //alert("请求--待办--失败"+error);
                    this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')), "请求--待办--失败" + error);//记录错误
                    console.log("请求--待办--失败" + error);
                });
            },
            getData: function (sid) {
                this.joa_page++;
                this.joa_loading = true;
                //var _h="Bearer "+"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmbGFnIjp0cnVlLCJkYXRhIjp7InVzZXJJZCI6NjEwLCJ1c2VybmFtZSI6Im1pbGxlci56aHUiLCJwYXNzd29yZCI6bnVsbCwiYXV0aG9yaXRpZXMiOm51bGwsImVuYWJsZWQiOnRydWUsImFjY2Vzc1Rva2VuIjpudWxsLCJyZWZyZXNoVG9rZW4iOm51bGwsImV4cGlyYXRpb24iOjE2MzAwMjc0MDMxMjcsImlkIjo2MTAsImNvZGUiOiI1MDAxNjU5IiwibmFtZSI6IuacseWwj-aIiCIsImVtYWlsIjoibWlsbGVyLnpodUBjZWNwb3J0LmNvbSIsImR1dHlMZXZlbE5hbWUiOiJNMyIsIm1vYmlsZSI6IjEzNTAwMDY1NjY3IiwiZGVwYXJ0bWVudElkIjo5NDQsImRlcGFydG1lbnROYW1lIjoi5Liw5byY5LqL5Lia6YOoIiwid3hVaWQiOiI1MDAxNjU5IiwiZGV2aWNlSWQiOiIxMDAwMDU5Njg1OTM4N0FSIiwiZnNzY1VybCI6Imh0dHBzOi8vZnNzYy5jZWNwb3J0LmNvbTo4NDQzL3d4QXV0aC8_ZnJvbT1qb2EmdG9rZW49RTA1N0JCNTE1QTQ3MjhGMEM3Q0VBNUI5RUZDOUJFNUImdW49MjI5RTU2MzIwNkI2NDhDMTE3QzI5ODYxNTJFQkIxQUQiLCJlaHJVcmwiOm51bGwsImJpVXJsIjoiaHR0cHM6Ly9iaS5jZWNwb3J0LmNvbS90b29scy9vdGhlcl9zeXNfbG9naW5fYWpheC5hc2h4P2FjdGlvbj1mcm9tX290aGVyX3N5c19sb2dpbl9yZWRpcmVjdCZ1c2VyX25hbWU9QzM5NURGN0VDNUVEQ0I3OTQ3ODY5OTk2OTg0MENFMjgmZHQ9NTRFOTc5MDQ0QTBEMDMyQ0Y4MDNCRDVDQzkzQTExQ0QiLCJwaWMiOiJodHRwczovL29hLmNlY3BvcnQuY29tL1VwbG9hZC9FbXBQaWMvUGhvdG9TdG9yYWdlL0JBQTlCRUZDNzA3NkU5M0Y2MUIzQkJDMDAxRjJFMDYyLmpwZyIsIm9hSWQiOiJCQUE5QkVGQy03MDc2LUU5M0YtNjFCMy1CQkMwMDFGMkUwNjIiLCJ3eE9wZW5pZCI6bnVsbCwiZHV0eU5hbWUiOiLmgLvnu4_nkIYiLCJwc3N3b3JkRGF0ZSI6MTYwMTEyODYzNDAwMCwiZGVsZXRlU3RhdHVzIjowLCJzdGF0dXMiOjEsImFjY291bnROb25FeHBpcmVkIjp0cnVlLCJjcmVkZW50aWFsc05vbkV4cGlyZWQiOnRydWUsImFjY291bnROb25Mb2NrZWQiOnRydWUsInBhc3N3b3JkTm9uV2VhayI6dHJ1ZX0sInVzZXJfbmFtZSI6Im1pbGxlci56aHUiLCJzY29wZSI6WyJhbGwiXSwiZXhwIjoxNjMwMDI3NDAzLCJqdGkiOiJhMDNmODI5Yy1iM2ZkLTRjOWEtOGYwYS0wNThhYjFjZWVlN2YiLCJjbGllbnRfaWQiOiJqb2Etd2ViIn0.PDDfmKcc2mBA0YwvAjF3k3QoBy-GDwaJNJ3SqBsTvOU";

                // axios.get(this.CoreNew.OA_API_IP + "joa-wf/mobile/todo", {
                axios.get(this.CoreNew.OA_API_IP + "api/wf/mobile/todo", {
                    params: {systemId: sid, pageSize: this.CoreNew.PAGESIZE, currentPage: this.joa_page},
                    //headers: {'Authorization':_h}
                    headers: {'Authorization': JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
                }).then(function (response) {
                    if (response.data.flag == true) {
                        console.log(response.data.data["total"])
                        if (response.data.data["total"] == 0) {
                            this.joa_list = [];
                            this.joa_loading = false;
                            this.joa_finished = true;
                            $(".no-datas").addClass("show");
                        } else {
                            var $rs = response.data;
                            if (typeof ($rs.data["records"]) == "string" && (sid == this.joa_systemId)) {
                                $(".no-datas").removeClass("show");
                                this.joa_total = $rs.data["total"];
                                var $list = JSON.parse($rs.data["records"]);
                                //if(sid="EHR"){
                                //	var files=JSON.parse($list[0].hrFiles);
                                //}
                                this.joa_list = this.joa_list.concat($list);
                                console.log(this.joa_list);
                                // 数据全部加载完成
                                this.joa_loading = false;
                                if (this.joa_list.length != 0 && (this.joa_list.length >= this.joa_total)) {
                                    //if (this.joa_list.length !=0 && ((this.joa_list.length+this.CoreNew.PAGESIZE) >= this.joa_total)) {
                                    this.joa_finished = true;
                                }/*else{
							this.getData(sid); //获取数据
						}*/
                            }
                        }
                    }
                }.bind(this)).catch(function (error) {
                    //alert("请求--待办--失败"+error);
                    this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')), "请求--待办--失败" + error);//记录错误
                    console.log("请求--待办--失败" + error);
                });
            },
            //onLoad: function () {
            //	this.getData(); //获取数据
            //},
            Color: function () {
                this.r = Math.floor(Math.random() * 255);
                this.g = Math.floor(Math.random() * 255);
                this.b = Math.floor(Math.random() * 255);
                //this.joa_color = 'rgba('+ this.r +','+ this.g +','+ this.b +',0.8)';
            }
        }
    };
</script>
